import Vue from 'vue';
import App from './App.vue';
import i18n from './i18n/index'; // 引入 i18n 配置
import router from './router/index';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

Vue.use(Antd);

new Vue({
  router,
  i18n, // 挂载 i18n
  render: (h) => h(App),
}).$mount('#app');